import { Badge, Checkbox, Text } from '@mantine/core';
import { IconEdit, IconPencil } from '@tabler/icons-react';
import _, { head, size } from 'lodash';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { useMemo, useState } from 'react';
import { BASE_URL } from '../../api/EndPoints';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

const MapProductGrid = ({
 data,
     column,
     editVariant,
     isLoading,
     map,
     vendorId,
     activeTab,
     isError,
     editVarientForMapped,
     handleSearchChange,
     onPaginationChange,
     pagination,
     manualPagination,
     rowCount,
     searchTerm,
     status,
     setStatus,
     selectedPairs = [],
     areAllSelected = false,
     handleSelectPair = () => { },
     handleSelectAllPairs = () => { },
 }) => {
     const pimId = data?.[0]?.pimId;
   const columns = useMemo(() => {
        const columnArray = [
            {
                id: 'product',
                columns: [
                    {
                        accessorKey: 'product.image',
                        header: 'Image',
                        size: 130,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => {
                            const image = row.original.image
                            return (
                                <div style={{ width: '50px', height: '50px', backgroundColor: 'var(--hs-color-bg-neutral-edge)', borderRadius: '5px', display: 'flex', alignItems: 'center' }}  >
                                    {image && image !== 'null' ? (
                                        <img src={`${BASE_URL}${image?.replace("/api", "")}?time=${Date?.now()}`}alt="Uploaded Badge" style={{ maxWidth: '50px', maxHeight: '50px' }} />
                                    ) : <span style={{ fontSize: 'smaller' }}>No image</span>}
                                </div>
                            );
                        }
                    },
                    {
                        accessorKey: 'createdDate',
                        header: 'Created Date',
                        size: 120,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => {
                            const timestamp = pimId ? row.original.product.createdDate : row.original.createdDate;
                            const formattedDate = new Date(Number(timestamp)).toLocaleDateString('en-GB'); 

                            return <span>{formattedDate}</span>;
                        },
                    },
                    {
                        accessorKey: 'articleCode',
                        header: 'Product Code',
                        size: 150,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => (
                            <span>{pimId ? row.original.product.articleCode : row.original.articleCode}</span>
                        ),
                    },
                    {
                        accessorKey: 'articleName',
                        header: 'Product Name',
                        size: 150,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => {
                            const hasVendor = !!row?.original?.vendorId;

                            return (
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span>
                                        {pimId ? row.original.product.articleName : row.original.articleName}
                                    </span>
                                    {hasVendor && (
                                        <Badge color="green" variant="light" size="xs">
                                            exclusive
                                        </Badge>
                                    )}
                                </div>
                            );
                        },
                    },
                    {
                        accessorKey: 'unitOfMeasures',
                        header: 'UOM',
                        size: 100,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => (
                            <span>{row.original?.otherInformation?.unitOfMeasures?.isKg ? 'KG' : row.original?.otherInformation?.unitOfMeasures?.isMeter ? 'Meter' :
                                row.original?.otherInformation?.unitOfMeasures?.isYard ? 'Yard' : 'N/A'}</span>
                        ),
                    },
                    ...(vendorId ? [{
                        header: 'Vendor Product Name',
                        accessorKey: 'vendorProductName',
                        size: 150,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => row.original.vendorProductName || 'N/A'
                    }] : []),
                    ...(vendorId ? [{
                        header: 'Vendor Product ID',
                        accessorKey: 'vendorProductId',
                        size: 120,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => row.original.vendorProductInfo?.vendorProductId || 'N/A'
                    }] : []),
                    {
                        accessorKey: 'name',
                        header: 'Taxonomy Name',
                        size: 150,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => (
                            <span>{pimId ? row?.original?.product?.taxonomyNode?.name : row?.original?.taxonomyNode?.name}</span>
                        ),
                    },
                    {
                        accessorKey: 'brand.name',
                        header: 'Brand',
                        size: 120,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ row }) => (
                            <span>{pimId ? row.original.product.brand.name : row.original?.brand?.name}</span>
                        ),
                    },
                    ...(vendorId ? [
                        {
                            header: 'Cost Price',
                            accessorKey: 'vendorProductInfo.costPrice',
                            size: 150,
                            Cell: ({ cell, row }) => {
                                const price = row.original?.vendorProductInfo?.costPrice;
                                return price ? price.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'INR',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) : 'N/A';
                            },
                        }
                    ] : [{
                        accessorKey: 'priceSetting.sellingPrice',
                        header: 'Price',
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ cell, row }) => {
                            const price = pimId ? row.original.product.priceSetting.sellingPrice : row.original.priceSetting?.sellingPrice;
                            return price ? price.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'INR',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }) : 'N/A';
                        },
                        size: 120
                    }]),
                    {
                        accessorKey: 'status',
                        header: 'Status',
                        size: 120,
                        enableSorting: false,
                        enableColumnDragging: false,
                        Cell: ({ cell, row }) => {
                            const status = pimId ? row.original.status : row.original.status;
                            return (
                                <span style={{ color: status === 'ACTIVE' ? 'green' : 'red' }}>
                                    {status}
                                </span>
                            );
                        },
                    },
                ],
            },
        ];

        columnArray[0].columns.push({
            header: (pimId ? 'Action' : "Actions"),
            enableSorting: false,
            enableColumnDragging: false,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
            size: 120,
            Cell: ({ row }) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                         <IconEdit size={18}
                                onClick={() => editVarientForMapped(row?.original?.productId, map)}
                                style={{ cursor: 'pointer', color: 'teal' }}
                            />
                    </div>
                );
            },
        });

        return columnArray;
    }, [pimId, map, areAllSelected, selectedPairs, data, activeTab]);
     const renderDetailPanel = ({ row }) => {
         const variants = pimId
             ? row.original.product?.productVariants
             : row.original.productVariants || [];
         const productName = pimId
             ? row.original.product?.vendorProductName
             : row.original.vendorProductName;
         if (!row.original.productVariants?.length > 0) {
             return null;
         }
 
         return (
             <div className="variant-detail-panel">
                 <p className="variant-count">Total Variants: {variants.length}</p>
                 {variants.length > 0 ? (
                     <div className="variant-table">
                         <table>
                             <thead>
                                 <tr>
                                     <th>Variant SKU</th>
                                     <th>Name</th>
                                 </tr>
                             </thead>
                             <tbody>
                                 {variants.map((variant, index) => (
                                     <tr key={index}>
                                         <td>{variant.variantSku || 'N/A'}</td>
                                         <td>
                                             {variant.name || 'N/A'}
                                         </td>
                                     </tr>
                                 ))}
                             </tbody>
                         </table>
                     </div>
                 ) : (
                     <p className="no-variants">No variants available</p>
                 )}
             </div>
         );
     };
 
     const finalPageCount = useMemo(() => {
         return (rowCount && pagination.pageSize
             ? Math.ceil(rowCount / pagination.pageSize)
             : 1);
     }, [rowCount, pagination.pageSize]);
 
     const table = useMaterialReactTable({
         columns: column || columns,
         data: data || [],
         manualPagination: true,
         rowCount,
         pageCount: finalPageCount,
         onPaginationChange,
         enableGlobalFilter: false,
         state: {
             pagination,
             isLoading,
             showAlertBanner: isError,
         },
         renderDetailPanel,
         enableColumnActions: false,
         enableColumnFilters: false,
         enableFullScreenToggle: false,
         enableDensityToggle: false,
         enableHiding: false,
         enableSorting: true,
         defaultColumn: {
             muiTableHeadCellProps: {
                 align: 'center',
                 className: 'table-header-cell',
             },
             muiTableBodyCellProps: {
                 align: 'center',
                 className: 'table-body-cell',
             },
         },
         muiTableHeadCellProps: {
             align: 'center',
             className: 'table-header-cell',
         },
         muiTableBodyCellProps: {
             align: 'center',
             className: 'table-body-cell',
         },
         mantineTableProps: {
             className: 'product-grid-table',
         },
         mantinePaginationProps: {
             className: 'pagination-bar',
             showRowsPerPage: false,
             showQuickJumper: false,
             showEllipsis: true,
         },
         renderTopToolbarCustomActions: () => (
             <div
                 className="search-barr-container"
                 style={{ display: 'flex', justifyContent: 'flex-end', position: 'relative', width: '250px' }}
             >
                 <input
                     placeholder="Search Products"
                     value={searchTerm}
                     onChange={(e) => handleSearchChange(e.target.value)}
                     style={{
                         borderRadius: 8,
                         border: '1px solid rgba(0,0,0,0.12)',
                         padding: '8px 35px 8px 10px',
                         width: '100%',
                         
                     }}
                 />
 
                 <svg
                     xmlns="http://www.w3.org/2000/svg"
                     width="16" height="16"
                     fill="gray"
                     style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}
                     viewBox="0 0 24 24"
                 >
                     <path d="M21 20l-5.6-5.6A7.9 7.9 0 0016 9a8 8 0 10-8 8 7.9 7.9 0 005.4-2.1L20 21l1-1zM4 9a5 5 0 1110 0A5 5 0 014 9z" />
                 </svg>
             </div>
 
         ),
         paginateExpandedRows: false,
     });
 
     return (
         <div className="product-grid-container">
             <MaterialReactTable table={table} />
         </div>
     );
 };
export default MapProductGrid;